import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getStocktake,
  getIdStocktake,
  createStocktake,
  updateStocktake,
  deleteStocktake,
  updateStocktakeSetStatus,
  updateStocktakeConfirm,
  updateStocktakeCancel,
  getVehicle,
  createVehicle,
  updateVehicle,
  deleteStocktakeVehicles,
  createParty,
  updateParty,
  deleteParty,
  getparty,
  getTransportations,
  createTransportations,
  updateTransportations,
  deleteTransportations,
  updateStocktakeStartWorkFlow,
  uploadStocktake,
  updateStocktakeAmend,
  uploadPicking,
  uploadBTS,
  updateStocktakeAmmend,
  updateStocktakeComplete,
  createStocktakeVehiclesUnplanned,
} from "./stocktakeAPI";

const initialState = {
  data: [],
  dataId: null,
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,

  permissionsCount: [],
  permissionsList: [],
};

export const fetchStocktake = createAsyncThunk(
  "Stocktake/fetchStocktake",
  async (payload) => {
    const response = await getStocktake(payload);
    return response;
  }
);

export const addStocktake = createAsyncThunk(
  "Stocktake/addStocktake",
  async (payload) => {
    const response = await createStocktake(payload);
    return response;
  }
);

export const editStocktake = createAsyncThunk(
  "Stocktake/editStocktake",
  async (payload) => {
    const response = await updateStocktake(payload);
    return response;
  }
);

export const editStocktakeConfirm = createAsyncThunk(
  "Stocktake/editStocktakeConfirm",
  async (payload) => {
    const response = await updateStocktakeConfirm(payload);
    return response;
  }
);
export const editStocktakeAmmend = createAsyncThunk(
  "Stocktake/editStocktakeAmend",
  async (payload) => {
    const response = await updateStocktakeAmmend(payload);
    return response;
  }
);
export const editStocktakeComplete = createAsyncThunk(
  "Stocktake/editStocktakeComplete",
  async (payload) => {
    const response = await updateStocktakeComplete(payload);
    return response;
  }
);
export const editStocktakeCancel = createAsyncThunk(
  "Stocktake/editStocktakeCancel",
  async (payload) => {
    const response = await updateStocktakeCancel(payload);
    return response;
  }
);

export const editStocktakeStarWorkflow = createAsyncThunk(
  "Stocktake/editStocktakeStarWorkflow",
  async (payload) => {
    const response = await updateStocktakeStartWorkFlow(payload);
    return response;
  }
);

export const fetchIdStocktake = createAsyncThunk(
  "Stocktake/fetchIdStocktake",
  async (id) => {
    const response = await getIdStocktake(id);
    return response;
  }
);

export const removeStocktake = createAsyncThunk(
  "Stocktake/removeStocktake",
  async (payload) => {
    const response = await deleteStocktake(payload);
    return response;
  }
);

export const AddUploadFile = createAsyncThunk(
  "Stocktake/AddUploadFile",
  async ({ id, file }) => {
    const response = await uploadStocktake(id, file);
    return response;
  }
);

export const AddUploadFilePicking = createAsyncThunk(
  "Stocktake/AddUploadFilePicking",
  async ({ id, file }) => {
    const response = await uploadPicking(id, file);
    return response;
  }
);
export const AddUploadFileBTS = createAsyncThunk(
  "Stocktake/AddUploadFileBTS",
  async ({ id, file }) => {
    const response = await uploadBTS(id, file);
    return response;
  }
);

// vihicle
export const fetchStocktakeVehicle = createAsyncThunk(
  "Stocktake/fetchStocktakeVehicle",
  async (payload) => {
    const response = await getVehicle(payload);
    return response;
  }
);

export const addStocktakeVehicle = createAsyncThunk(
  "Stocktake/addStocktakeVehicle",
  async (payload) => {
    const response = await createVehicle(payload);
    return response;
  }
);

export const addStocktakeVehicleUnplaned = createAsyncThunk(
  "Stocktake/addStocktakeVehicleUnplaned",
  async (payload) => {
    const response = await createStocktakeVehiclesUnplanned(payload);
    return response;
  }
);


export const removeStocktakeVehicle = createAsyncThunk(
  "Stocktake/removeStocktakeVehicle",
  async (payload) => {
    const response = await deleteStocktakeVehicles(payload);
    return response;
  }
);

export const editStocktakeVehicle = createAsyncThunk(
  "Stocktake/editStocktakeVehicle",
  async (payload) => {
    const response = await updateVehicle(payload);
    return response;
  }
);

// party
export const fetchStocktakeParty = createAsyncThunk(
  "Stocktake/fetchStocktakeParty",
  async (payload) => {
    const response = await getparty(payload);
    return response;
  }
);
export const fetchStocktakePartyAll = createAsyncThunk(
  "Stocktake/fetchStocktakePartyAll",
  async (payload) => {
    const response = await getparty(payload);
    return response;
  }
);

export const addStocktakeParty = createAsyncThunk(
  "Stocktake/addStocktakeParty",
  async (payload) => {
    const response = await createParty(payload);
    return response;
  }
);

export const editStocktakeParty = createAsyncThunk(
  "Stocktake/editStocktakeParty",
  async (payload) => {
    const response = await updateParty(payload);
    return response;
  }
);

export const removeStocktakeParty = createAsyncThunk(
  "Stocktake/removeStocktakeParty",
  async (payload) => {
    const response = await deleteParty(payload);
    return response;
  }
);

export const stocktakeSlice = createSlice({
  name: "stocktake",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },

    setPermisionCount: (state, action) => {
      state.permissionsCount = action.payload;
    },
    setPermisionList: (state, action) => {
      state.permissionsList = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStocktake.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchStocktake.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })
      .addCase(fetchIdStocktake.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIdStocktake.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })

      .addCase(addStocktake.pending, (state) => {
        state.loading = true;
      })
      .addCase(addStocktake.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })

      .addCase(editStocktake.pending, (state) => {
        state.loading = true;
      })
      .addCase(editStocktake.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editStocktakeConfirm.pending, (state) => {
        state.loading = true;
      })
      .addCase(editStocktakeConfirm.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editStocktakeAmmend.pending, (state) => {
        state.loading = true;
      })
      .addCase(editStocktakeAmmend.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editStocktakeComplete.pending, (state) => {
        state.loading = true;
      })
      .addCase(editStocktakeComplete.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editStocktakeCancel.pending, (state) => {
        state.loading = true;
      })
      .addCase(editStocktakeCancel.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editStocktakeStarWorkflow.pending, (state) => {
        state.loading = true;
      })
      .addCase(editStocktakeStarWorkflow.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(AddUploadFile.pending, (state) => {
        state.loading = true;
      })
      .addCase(AddUploadFile.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(AddUploadFilePicking.pending, (state) => {
        state.loading = true;
      })
      .addCase(AddUploadFilePicking.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(AddUploadFileBTS.pending, (state) => {
        state.loading = true;
      })
      .addCase(AddUploadFileBTS.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeStocktake.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeStocktake.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(fetchStocktakeVehicle.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchStocktakeVehicle.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })
      .addCase(addStocktakeVehicle.pending, (state) => {
        state.loading = true;
      })
      .addCase(addStocktakeVehicle.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(addStocktakeVehicleUnplaned.pending, (state) => {
        state.loading = true;
      })
      .addCase(addStocktakeVehicleUnplaned.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editStocktakeVehicle.pending, (state) => {
        state.loading = true;
      })
      .addCase(editStocktakeVehicle.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeStocktakeVehicle.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeStocktakeVehicle.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const { resetData, setSelected,setPermisionCount,setPermisionList } = stocktakeSlice.actions;

export const selectStocktake = (state) => state.stocktake.data;
export const selectStocktakeVehicle = (state) => state.stocktake.data;
export const selectIdStocktake = (state) => state.stocktake.dataId;
export const selectLoading = (state) => state.stocktake.loading;
export const selectError = (state) => state.stocktake.error;
export const selectPageNo = (state) => state.stocktake.pageNo;
export const selectPageSize = (state) => state.stocktake.pageSize;
export const selectTotalRecord = (state) => state.stocktake.totalRecord;
export const selectSelected = (state) => state.stocktake.selected;
export const selectResult = (state) => state.stocktake.result;

export const selectPermissionCount = (state) => state.stocktake.permissionsCount;
export const selectPermissionList = (state) => state.stocktake.permissionsList;

export default stocktakeSlice.reducer;
